package com.appsyde.shared.presentation.screen.screen

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import com.appsyde.shared.presentation.style.AppStylesLanding
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.dom.*

@Composable
fun LegalPage() {
    DisposableEffect(Unit) {
        val meta = document.createElement("meta")
        meta.setAttribute("name", "robots")
        meta.setAttribute("content", "noindex, nofollow")
        document.head?.appendChild(meta)
        onDispose {
            document.head?.removeChild(meta)
        }
    }
    Style(AppStylesLanding)
    LegalPageLayout(
        title = "Mentions légales",
        content = {
            P({ classes(AppStylesLanding.legalUpdated) }) { Text("Dernière mise à jour : 10 mars 2026") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Conformément aux dispositions des articles 6-III et 19 de la Loi pour la Confiance dans l'Économie Numérique (LCEN), les présentes mentions légales sont portées à la connaissance des utilisateurs du site et du service AppSyde.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("1. Éditeur du service") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Le site et la plateforme AppSyde sont édités par :")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                B { Text("APPSYDE") }
                Br()
                Text("EURL au capital de ")
                B { Text("1000") }
                Text(" euros")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Siège social :")
                Br()
                B { Text("25 RUE LUCIEN BOXTAEL 95370 MONTIGNY-LES-CORMEILLES") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("SIREN : ")
                B { Text("989397328") }
                Br()
                Text("RCS : ")
                B { Text("Pontoise") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Directeur de la publication :")
                Br()
                B { Text("AppSyde") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Contact :")
                Br()
                Text("Email : ")
                A("mailto:appsyde.tb.help@gmail.com", { classes(AppStylesLanding.navLink) }) { Text("appsyde.tb.help@gmail.com") }
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("2. Hébergement") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Le site et les ressources statiques du service AppSyde sont hébergés par :")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                B { Text("Netlify, Inc.") }
                Br()
                Text("2325 3rd Street, Suite 296")
                Br()
                Text("San Francisco, CA 94107")
                Br()
                Text("United States")
                Br()
                A("https://www.netlify.com", { classes(AppStylesLanding.navLink); attr("target", "_blank"); attr("rel", "noopener noreferrer") }) { Text("https://www.netlify.com") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("L'infrastructure applicative et les services backend sont hébergés par :")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                B { Text("Fly.io, Inc.") }
                Br()
                Text("679 Bryant Street #300")
                Br()
                Text("San Francisco, CA 94107")
                Br()
                Text("United States")
                Br()
                A("https://fly.io", { classes(AppStylesLanding.navLink); attr("target", "_blank"); attr("rel", "noopener noreferrer") }) { Text("https://fly.io") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Les serveurs utilisés pour le service AppSyde sont déployés dans des centres de données situés en Europe (région CDG – Paris).")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("3. Description du service") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("AppSyde est une plateforme logicielle (SaaS) destinée à assister les équipes de support client dans la gestion et la rédaction de réponses aux emails de support.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Le service peut inclure notamment :")
            }
            Ul({ classes(AppStylesLanding.legalList) }) {
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("l'organisation des conversations email") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("la génération de brouillons de réponses assistés par intelligence artificielle") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("l'extraction d'informations utiles dans les conversations") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("des outils de collaboration pour équipes support") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Les suggestions générées par AppSyde sont fournies ")
                B { Text("à titre d'assistance uniquement") }
                Text(" et doivent être validées par un agent humain avant tout envoi.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("4. Accès au service") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("L'accès au service peut nécessiter la création d'un compte utilisateur.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("L'utilisateur est responsable :")
            }
            Ul({ classes(AppStylesLanding.legalList) }) {
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("de la confidentialité de ses identifiants") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("de l'utilisation faite de son compte") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("de l'exactitude des informations fournies lors de l'inscription") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("AppSyde ne saurait être tenu responsable d'un accès non autorisé résultant d'une négligence de l'utilisateur.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("5. Propriété intellectuelle") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("L'ensemble du site et de la plateforme AppSyde, y compris notamment :")
            }
            Ul({ classes(AppStylesLanding.legalList) }) {
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("le logiciel") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("l'interface utilisateur") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("les textes") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("les éléments graphiques") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("les logos et la marque") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("sont protégés par les lois relatives à la propriété intellectuelle.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Toute reproduction, modification, distribution ou exploitation non autorisée de ces éléments est interdite sans autorisation préalable.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("6. Responsabilité") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("AppSyde met en œuvre tous les moyens raisonnables pour assurer le bon fonctionnement du service.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Toutefois, l'éditeur ne peut garantir :")
            }
            Ul({ classes(AppStylesLanding.legalList) }) {
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("l'absence totale d'erreurs") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("une disponibilité continue du service") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("l'exactitude des suggestions générées par les outils d'intelligence artificielle") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("L'utilisateur reste seul responsable des réponses envoyées à ses propres clients.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("En aucun cas AppSyde ne pourra être tenu responsable des dommages indirects résultant de l'utilisation du service.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("7. Données personnelles") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Le traitement des données personnelles est décrit dans la ")
                B { Text("Politique de confidentialité (Privacy Policy)") }
                Text(" accessible sur le site.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("AppSyde s'engage à traiter les données conformément à la réglementation applicable, notamment le ")
                B { Text("Règlement Général sur la Protection des Données (RGPD)") }
                Text(".")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("8. Cookies") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Le service peut utiliser des cookies techniques nécessaires au bon fonctionnement de la plateforme.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Ces cookies permettent notamment :")
            }
            Ul({ classes(AppStylesLanding.legalList) }) {
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("la gestion des sessions utilisateurs") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("la sécurité du service") }
                Li({ classes(AppStylesLanding.legalListItem, AppStylesLanding.cardBody) }) { Text("l'amélioration de l'expérience utilisateur") }
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Aucun cookie publicitaire n'est utilisé.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("9. Liens externes") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Le site ou la plateforme peuvent contenir des liens vers des sites tiers.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("AppSyde ne peut être tenu responsable du contenu ou des pratiques de ces sites externes.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("10. Droit applicable") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Les présentes mentions légales sont régies par le droit français.")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("En cas de litige relatif à l'utilisation du service, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.")
            }
            Div({ classes(AppStylesLanding.divider) })

            H2({ classes(AppStylesLanding.legalH2) }) { Text("11. Contact") }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Pour toute question concernant les présentes mentions légales ou le fonctionnement du service :")
            }
            P({ classes(AppStylesLanding.cardBody) }) {
                Text("Email : ")
                A("mailto:appsyde.tb.help@gmail.com", { classes(AppStylesLanding.navLink) }) { Text("appsyde.tb.help@gmail.com") }
            }
        }
    )
}
